import { useEffect, useState, useContext, useRef } from "react";
import { createBrowserRouter, RouterProvider, useNavigate } from "react-router";
import axios from 'axios';

import { AppContext } from '../../../context.js';

import Helmet from "../../components/helmet.js";
import { PhysicianAvatar, Status, Button, Counter } from '../../components/component.js';
import { Image } from "../../components/filePreview.js";
import { FilePlus, UserPlus, Edit } from "../../../files/icons/index.js";

import { FullName } from '../../../utils/string.js';

function Users() {
  const context = useContext(AppContext);

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);

  const [users, setUsers] = useState(null);

  useEffect(() => {
    let u = context.addSpiner();
    axios.all([
      axios.post('/api/admin/physicians', {
        filter: {
          status: ["DRAFT", "ACTIVE", "ARCHIVED"],
        }
      }),
    ]).then(axios.spread((physicians) => {
      setUsers(physicians.data.physicians);
      setLoading(false);
    })).catch((e) => {
      context.addError(e);
      context.removeSpiner(u);
    }).finally(() => {
      context.removeSpiner(u);
    });
  }, []);

  function renderUsers() {
    if (!users || users.length === 0) {
      return (
        <div className="d-flex justify-content-center align-items-center mt-4">
          <div className="typo-normal-150 text-muted">No users</div>
        </div>
      );
    }

    const filteredUsers = users.filter((user) => user.id !== "000000000000000000000001");

    if (filteredUsers.length === 0) {
      return (
        <div className="d-flex justify-content-center align-items-center mt-4">
          <div className="typo-normal-150 text-muted">No users</div>
        </div>
      );
    }

    return filteredUsers.map((user, i) => {
      return (
        <div key={user.id} className="card clickable mb-2" onClick={() => navigate(`/settings/user/${user.id}`)}>
          <div className="card-header sm">
            <div className="d-flex justify-content-start align-items-center">
              <PhysicianAvatar id={user.id} alt="logo" style={{height: 50, width: 50}} />
              <div className="w-50 ms-2">
                <div className="typo-strong-200">{FullName(user.firstName, user.middleName, user.lastName)}</div>
                <div className="typo-normal-150">{user.speciality}</div>
              </div>
              <div className="w-25">
                <div className="typo-strong-150">{user.provider ? "Provider" : "Non-Provider"}</div>
                {user.npi && <div className="typo-normal-150">NPI: {user.npi}</div>}
              </div>
              <div className="w-25 text-end">
                {renderPhysicianStatus(user)}
                <div className="typo-normal-150 mt-1">{user.staffRole === "admin" ? "Admin" : "Navigator"}</div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  }

  function renderPhysicianStatus(physician) {
    if (physician.statusType === "DRAFT") {
      return <Status color={'blue'} muted={true} text={'Draft'} />;
    }
    if (physician.statusType === "ACTIVE") {
      return <Status color={'green'} muted={true} text={'Active'} />;
    }
    if (physician.statusType === "ARCHIVED") {
      return <Status color={'grey'} muted={true} text={'Disabled'} />;
    }
    return null;
  }

  if (loading) {
    return <></>;
  }

  return (
    <>
      <Helmet title="Settings | Users" />

      <div className="container-fluid">
        <div className="row mb-4">
          <div className="col-xs-12 col-lg-offset-2 col-lg-8">
            <div className="d-flex justify-content-between align-items-center">
              <div className="">
                <div className="typo-hero-small">Users</div>
                <div className="typo-normal-175">Manage and monitor all physician user accounts within the system</div>
              </div>
              <div className="w-25 text-end">
                {context.isAdmin && (
                  <div className="item typo-normal-150 ms-2" onClick={() => navigate('/settings/users/create')}><UserPlus height={16} width={16} color={'grey'} /> Create User</div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-lg-offset-2 col-lg-8">

            {renderUsers()}

          </div>
        </div>
      </div>
    </>
  );
}

export default Users;